var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.367,
    height: 37.975,
    viewBox: "0 0 45.367 37.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475",
    transform: "translate(-22.494 -0.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M105.148,86.617V97.762h32.824c6.092,0,11.03-2.855,11.03-6.372V80.249c0,3.517-4.938,6.368-11.03,6.368Z",
    transform: "translate(-81.897 -59.843)",
    fill: "#ebeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M105.148,22.639v7.807h32.824c6.092,0,11.03-2.85,11.03-6.367,0-1.759-1.237-3.353-3.232-4.5a15.855,15.855,0,0,0-7.8-1.87H127.207V11.5c0-3.517-4.937-6.368-11.03-6.368a15.86,15.86,0,0,0-7.8,1.865c-2,1.15-3.232,2.739-3.232,4.5Z",
    transform: "translate(-81.897 -3.673)",
    fill: "#ebeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M135.728,28.96H102.9a.757.757,0,0,1,0-1.513h32.824c5.569,0,10.273-2.569,10.273-5.61,0-1.421-1.014-2.787-2.853-3.847a15.056,15.056,0,0,0-7.42-1.769H124.963a.757.757,0,0,1-.757-.757V9.255c0-3.041-4.7-5.611-10.273-5.611a15.068,15.068,0,0,0-7.419,1.763c-1.841,1.061-2.854,2.427-2.854,3.848V20.377a.757.757,0,1,1-1.513,0V9.255c0-1.984,1.282-3.817,3.611-5.159a16.588,16.588,0,0,1,8.175-1.966c6.609,0,11.786,3.129,11.786,7.124v5.451h10.008a16.582,16.582,0,0,1,8.177,1.972c2.327,1.341,3.61,3.173,3.61,5.158,0,3.995-5.177,7.124-11.787,7.124",
    transform: "translate(-79.653 -1.43)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M135.728,91.951H102.9a.757.757,0,0,1-.757-.757V72.222a.757.757,0,0,1,1.513,0V90.438h32.067c5.569,0,10.273-2.572,10.273-5.616V73.681a.757.757,0,1,1,1.513,0V84.822c0,4-5.177,7.129-11.787,7.129",
    transform: "translate(-79.653 -53.275)",
    fill: "#cba04b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.0b4a458f7b6b1e79547e46d6e893f6e5.svg";
export { ForwardRef as ReactComponent };